import React from 'react';
import { observer } from 'mobx-react';
import CookiesPolicyComponent from './Cookies-policy.component';
import useCookiesPolicy from './useCookiesPolicy';

const Container = () => {
    const { app, lang, handlers } = useCookiesPolicy();

    return (
        <>
            <CookiesPolicyComponent
                lang={lang.lang}
                approved={app.cookiesApproved}
                onApprove={handlers.handleApprove}
            />
        </>
    );
};

const CookiesPolicyContainer = observer(Container);

export default CookiesPolicyContainer;
